import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.jpg';

const NAV_LINKS = [
  { label: 'About', path: '/about' },
  { label: 'Platform', path: '/platform' },
  { label: 'Science', path: '/science' },
  { label: 'Research', path: '/research' },
  { label: 'Investors', path: '/investors' },
  { label: 'News', path: '/news' },
  { label: 'Careers', path: '/career' },
  { label: 'Affiliations', path: '/affiliations.html', external: true },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setMobileOpen(false), [location]);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? 'rgba(8,13,26,0.95)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : '1px solid transparent',
      transition: 'all 0.3s ease',
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 72 }}>
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <div style={{
            background: '#7ECDC8',
            borderRadius: 7,
            padding: '3px 10px',
            display: 'flex',
            alignItems: 'center',
          }}>
            <img src={logo} alt="Alercell Oncology" style={{ height: 36, width: 'auto' }} />
          </div>
        </Link>

        {/* Desktop Nav */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }} className="desktop-nav">
         {NAV_LINKS.map(link => {
            const sharedStyle = {
              fontFamily: 'var(--font-display)', fontSize: 14, fontWeight: 500,
              color: location.pathname === link.path ? 'var(--accent-cyan)' : 'var(--text-secondary)',
              textDecoration: 'none', padding: '8px 14px', borderRadius: 6,
              transition: 'all 0.2s', background: location.pathname === link.path ? 'var(--accent-cyan-dim)' : 'transparent',
            };
            return link.external
              ? <a key={link.path} href={link.path} style={sharedStyle}>{link.label}</a>
              : <Link key={link.path} to={link.path} style={sharedStyle}>{link.label}</Link>;
          })}
        </div>

        {/* CTA */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Link to="/contact" className="btn btn-primary" style={{ fontSize: 13, padding: '9px 20px' }}>
            Contact Us
          </Link>
          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-primary)', padding: 8, display: 'none' }}
            className="mobile-toggle"
          >
            <span style={{ fontSize: 22 }}>{mobileOpen ? '✕' : '☰'}</span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div style={{
          background: 'rgba(8,13,26,0.98)', borderTop: '1px solid var(--border)',
          padding: '20px 20px 28px',
        }}>
          {NAV_LINKS.map(link => {
            const mobileStyle = {
              display: 'block', fontFamily: 'var(--font-display)', fontSize: 16,
              color: 'var(--text-primary)', textDecoration: 'none', padding: '12px 0',
              borderBottom: '1px solid var(--border)',
            };
            return link.external
              ? <a key={link.path} href={link.path} style={mobileStyle}>{link.label}</a>
              : <Link key={link.path} to={link.path} style={mobileStyle}>{link.label}</Link>;
          })}
          <Link to="/contact" className="btn btn-primary" style={{ marginTop: 20, width: '100%', justifyContent: 'center' }}>
            Contact Us
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-toggle { display: block !important; }
        }
      `}</style>
    </nav>
  );
}
